/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_BookedInputs */

const en_roster_booked = /** @type {(inputs: Roster_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked`)
};

const es_roster_booked = /** @type {(inputs: Roster_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservado`)
};

const fr_roster_booked = /** @type {(inputs: Roster_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservé`)
};

const de_roster_booked = /** @type {(inputs: Roster_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebucht`)
};

const id_roster_booked = /** @type {(inputs: Roster_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dipesan`)
};

/** @type {(inputs: Roster_BookedInputs) => LocalizedString} */
const ja_roster_booked = en_roster_booked;

/** @type {(inputs: Roster_BookedInputs) => LocalizedString} */
const zh_roster_booked = en_roster_booked;

/** @type {(inputs: Roster_BookedInputs) => LocalizedString} */
const ar_roster_booked = en_roster_booked;

/** @type {(inputs: Roster_BookedInputs) => LocalizedString} */
const it_roster_booked = en_roster_booked;

/** @type {(inputs: Roster_BookedInputs) => LocalizedString} */
const ru_roster_booked = en_roster_booked;

/** @type {(inputs: Roster_BookedInputs) => LocalizedString} */
const pt_roster_booked = en_roster_booked;

/** @type {(inputs: Roster_BookedInputs) => LocalizedString} */
const ko_roster_booked = en_roster_booked;

/**
* | output |
* | --- |
* | "Booked" |
*
* @param {Roster_BookedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_booked = /** @type {((inputs?: Roster_BookedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_BookedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_booked(inputs)
	if (locale === "es") return es_roster_booked(inputs)
	if (locale === "fr") return fr_roster_booked(inputs)
	if (locale === "de") return de_roster_booked(inputs)
	if (locale === "ja") return ja_roster_booked(inputs)
	if (locale === "zh") return zh_roster_booked(inputs)
	if (locale === "ar") return ar_roster_booked(inputs)
	if (locale === "id") return id_roster_booked(inputs)
	if (locale === "it") return it_roster_booked(inputs)
	if (locale === "ru") return ru_roster_booked(inputs)
	if (locale === "pt") return pt_roster_booked(inputs)
	return ko_roster_booked(inputs)
});